import React, { useState } from 'react';
import { Link } from 'gatsby';
import Button from '../../../../Button/Button';

import plusSvg from '../../../../../assets/img/icon/plus-btn.svg';
import minusSvg from '../../../../../assets/img/icon/minus-btn.svg';

import './QuestionAnswer.scss';

const parseURL = text => {
  const regexURL = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g
  const regexLink = /\/link\/\w*/g

  return text.split(" ").map(el => 
      regexLink.test(el) 
      ? <Link to={el.replace('/link', '')}>(Link)</Link>
      : regexURL.test(el)
          ? <a href={el} target="_blank" rel="noreferrer">{el}</a>
          : el + " "
  )
}
  
const QuestionAnswer = ({q, ans, currentLangKey}) => {
  const [toggle, setToggle] = useState(false);

  const handleToggleClick = () => setToggle(!toggle)

  return (
    <div className="qa-set" onClick={handleToggleClick} role="tab" onKeyDown={ handleToggleClick } tabIndex="0" >
      <div className="qa-set-wrapper">
        <div className="question">{q}</div>
        {toggle && <div className="answer">{parseURL(ans)}</div>}
      </div>
      <Button type="toggleUsingProps" toggleProps={toggle} imgOrginal={plusSvg} imgToggled={minusSvg} callback={handleToggleClick}/>
    </div>
  )
}

export default QuestionAnswer


// {questionAnsSets.map((qa, index) => {
//   return (
//     <div className="qa-set" key={index}>
//       {/* <div>{qa.q}</div>
//       <div>{qa.a}</div>
//       <Button type="toggle" imgOrginal={plusSvg} imgToggled={minusSvg} callback={handleToggleClick}/> */}
//       <div>abc</div>
//     </div>
//   )
// })}